import { ChangeDetectorRef, Component, ChangeDetectionStrategy, inject, input, linkedSignal } from '@angular/core';

@Component({
    selector: 'toogle-switch',
    imports: [],
    templateUrl: './toogle-switch.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './toogle-switch.component.scss'
})
export class ToogleSwitchComponent {
  private cdr = inject(ChangeDetectorRef);


  public readonly isOn = input.required<boolean>();
  /** État local : initialisé par l'input, modifiable par l'utilisateur */
  protected readonly isOnState = linkedSignal(() => this.isOn());

  public readonly data = input<any>({});
  
  setToOn() {
    if (this.isOnState()) return;

    this.isOnState.set(true);
    this.cdr.detectChanges();
  }

  setToOff() {
    if(!this.isOnState())return;

    this.isOnState.set(false);
    this.cdr.detectChanges();
  }
}
